
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { ExternalLink } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";

const Blog = () => {
  const { toast } = useToast();

  const handleDownload = (index: number) => {
    // This is where you would add the actual PDF URLs
    const pdfUrls = [
      "/path-to-your-pdf-1.pdf",
      "/path-to-your-pdf-2.pdf",
      "/path-to-your-pdf-3.pdf",
      "/path-to-your-pdf-4.pdf",
      "/path-to-your-pdf-5.pdf",
      "/path-to-your-pdf-6.pdf",
      "/path-to-your-pdf-7.pdf",
      "/path-to-your-pdf-8.pdf",
      "/path-to-your-pdf-9.pdf",
    ];

    // For now, show a toast since PDFs aren't actually available
    toast({
      title: "Coming Soon",
      description: `PDF Resource #${index + 1} will be available for download shortly.`,
    });

    // When you have actual PDFs, you would use this code:
    // const link = document.createElement('a');
    // link.href = pdfUrls[index];
    // link.download = `Resource-${index + 1}.pdf`;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen bg-surface">
      <Navbar />
      <main className="container mx-auto px-6 py-32 max-w-7xl">
        <h1 className="text-[2.5rem] md:text-[2.75rem] font-charter font-medium text-primary mb-12">
          Blog
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[...Array(9)].map((_, index) => (
            <article 
              key={index}
              className={`bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow ${
                index < 3 ? 'bg-[#F2FCE2]' : 
                index < 6 ? 'bg-[#FEC6A1]' : 
                'bg-[#E5DEFF]'
              }`}
            >
              <div className="flex items-start justify-between mb-6">
                <h2 className="text-2xl font-charter font-medium text-primary">
                  {index === 0 ? "Comprehensive Media Planning Guide" : 
                   index === 1 ? "Ad Account Health Checklist" : 
                   index === 2 ? "Ideal Customer Guide" :
                   index === 3 ? "Brand Building Guide" :
                   index === 4 ? "Budget Optimization Guide" :
                   index === 5 ? "Omnichannel Budgeting Masterclass" :
                   index === 6 ? "Guide to Customer Awareness Stages" :
                   index === 7 ? "Paid Ads Optimization Playbook" :
                   "Ultimate Customer Journey Guide"}
                </h2>
                <a
                  href={index === 1 ? "https://plannifi.kit.com/accounthealth" : 
                        index === 2 ? "https://plannifi.kit.com/customerguide" :
                        index === 3 ? "https://plannifi.kit.com/brandguide" :
                        index === 4 ? "https://plannifi.kit.com/budgetoptimization" :
                        index === 5 ? "https://plannifi.kit.com/budgetingmasterclass" :
                        index === 6 ? "https://plannifi.kit.com/customerstages" :
                        index === 7 ? "https://plannifi.kit.com/optimizationguide" :
                        index === 8 ? "https://plannifi.kit.com/customerjourney" :
                        "https://plannifi.kit.com/mediaplanning"}
                  target="_blank"
                  rel="noopener noreferrer" 
                  className="hover:bg-black/5 p-2 rounded-full inline-flex items-center justify-center"
                >
                  <ExternalLink className="h-6 w-6 text-secondary" />
                </a>
              </div>
              <p className="text-secondary mb-4">
                {index === 0 
                  ? "Learn strategic frameworks and methodologies for effective media planning across channels and platforms."
                  : index === 1
                  ? "A step-by-step checklist to audit, optimize, and maintain healthy advertising accounts across platforms."
                  : index === 2
                  ? "Discover proven methods to identify, analyze, and develop your ideal customer profile for targeted marketing."
                  : index === 3
                  ? "Comprehensive strategies to build a strong, cohesive brand identity that resonates with your target audience."
                  : index === 4
                  ? "Learn data-driven tactics to allocate your marketing budget efficiently and maximize campaign ROI."
                  : index === 5
                  ? "Advanced strategies for optimizing budget allocation across multiple marketing channels."
                  : index === 6
                  ? "Understanding the customer awareness journey: from problem unaware to most aware and how to target each stage."
                  : index === 7
                  ? "Expert techniques to optimize your paid advertising campaigns for better performance and lower costs."
                  : "Map and optimize every touchpoint in your customer's journey from discovery to loyalty."
                }
              </p>
              <div className="flex items-center justify-between mt-6">
                <span className="text-sm text-primary font-medium">
                  {Math.floor(Math.random() * 20 + 10)} pages
                </span>
              </div>
            </article>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Blog;
